//CREDENTIALS
export const formattingCPF = (cpf: string): string => {
  cpf.replace(/[^\d]/g, "");

  do {
    cpf = cpf.length < 11 ? "0" + cpf : cpf;
  } while (cpf.length < 11);

  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export const formattingCNPJ = (cnpj: string): string => {
  cnpj.replace(/[^\d]/g, "");

  do {
    cnpj = cnpj.length < 14 ? "0" + cnpj : cnpj;
  } while (cnpj.length < 14);

  return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}


//DATES
export const formattingDate = (date: string | Date, hasTime: boolean = false): string => {
  const newDate = new Date(date);

  let dateFormate = hasTime ? new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short'
  }).format(newDate)
    :
    new Intl.DateTimeFormat('pt-BR', {
      dateStyle: 'short'
    }).format(newDate);

  return dateFormate;
}

export const convertDateToSendPOST = (dateValue: any): string => {
  const date = new Date(dateValue),
    month = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), month, day].join("-");
}

export const convertDateToShowInput = (dateValue: any): string => {
  const date = new Date(dateValue),
    month = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), month, day].reverse().join("/");
}

export const convertDateTimeToSendPOST = (dateValue: any): string => {
  const date = new Date(dateValue);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day   = ("0" + date.getDate()).slice(-2);
  const hours = ("0" + date.getHours()).slice(-2);
  const mins  = ("0" + date.getMinutes()).slice(-2);
  return `${date.getFullYear()}-${month}-${day}T${hours}:${mins}:00`;
};

export const convertDateTimeToShowInput = (dateValue: any): string => {
  const date  = new Date(dateValue);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day   = ("0" + date.getDate()).slice(-2);
  const hours = ("0" + date.getHours()).slice(-2);
  const mins  = ("0" + date.getMinutes()).slice(-2);
  return `${day}/${month}/${date.getFullYear()} ${hours}:${mins}`;
};

//NUMBERS AND CURRENCIES
const numbersDictionary = [null, null, null, null, 'Mil', 'Mil', 'Mil', 'Milhões', 'Milhões', 'Milhões', 'Bilhões', 'Bilhões', 'Bilhões'];

export function formattingOnlyNumber(value: number | string): string {
  let clearWords = String(value).replace(/\D+/g, '');
  let transformValue = clearWords.replace(/(.)(?=(\d{3})+$)/g, '$1.');

  return transformValue === undefined || !transformValue ? "" : transformValue;
}

export function formattingOnlyNumberCurrency(value: number | string): string {
  var fixedValue;
  if (typeof value === 'number') {
    fixedValue = value.toFixed(2);
  } else {
    fixedValue = Number(value).toFixed(2);
  }
  return `R\$ ${fixedValue}`
}

export function formattingCurrency(value: number | string): string {
  let clearWords = Number(String(value).replace(/\D+/g, ''));
  let transformValue = (clearWords / 100).toLocaleString('pt-BR', { style: "currency", currency: "BRL" });

  return transformValue === undefined || !transformValue ? "" : transformValue;
}

export function formattingNumberToText(value: number | string): string {
  var valueLength, transformValue;
  if (typeof value === 'number') {
    valueLength = Math.log(value) * Math.LOG10E + 1 | 0;
    transformValue = value.toString().replace(/(.)(?=(\d{3})+$)/g, '$1.');
  } else {
    valueLength = value.length;
    transformValue = value.replace(/(.)(?=(\d{3})+$)/g, '$1.');
  }
  const mostSignificantDigits = transformValue.split('.')[0];
  return `${mostSignificantDigits} ${numbersDictionary[valueLength] ?? ''}`;
}

//PHONE NUMBERS
export function formattingPhoneNumber(value: string): string | undefined {
  const cleanValue = value.replace(/\+[0-9]{2}/, '');
  if (!!cleanValue) {
    if (cleanValue.startsWith('0800')) {
      return cleanValue.replace(/(.{4})(.{3})(.{4})/, "$1 $2 $3");
    } else if (cleanValue.length >= 11) {
      return cleanValue.replace(/(.{2})(.{1})(.{4})(.{4})/, "($1) $2 $3-$4");
    } else {
      return cleanValue.replace(/(.{2})(.{4})(.{4})/, "($1) $2-$3");
    }
  }
}